import { useAllPages } from "@/lib/collections/use-script-pages";
import { useDeviceHeartbeat } from "../hooks/use-device-heartbeat";
import { useReviewStatePoll } from "../hooks/use-review-state-poll";
import { useUploadWakeLock } from "../hooks/use-upload-wake-lock";

/** Wraps both capture routes (Home, script-detail) so the review-state
 * poller runs regardless of which one is open — a phone left on the
 * detail screen must still learn about an Approve/Flag from the desk. The
 * heartbeat and the wake lock sit here for the same reason: the desk must
 * be able to see this device's backlog, and the screen must stay up while
 * it drains, whichever capture screen the scanner left open. */
export function ScriptsShell({ children }: { children: React.ReactNode }) {
  useReviewStatePoll();
  useDeviceHeartbeat();
  useUploadWakeLock(useAllPages().some(p => p.uploadStatus !== "uploaded"));
  return <>{children}</>;
}
